import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@rtkwlf/pro-solid-svg-icons/faAngleLeft';
import { useTranslation } from 'react-i18next';

import type { LinkButtonProps } from '@packages/components/link-button';
import { LinkButton } from '@packages/components/link-button';

type PageToolbarBackProps = Omit<LinkButtonProps, 'iconLeft' | 'children'>;

export const PageToolbarBack: React.FC<PageToolbarBackProps> = (props) => {
  const { t } = useTranslation();

  return (
    <LinkButton
      variant="link"
      iconLeft={<FontAwesomeIcon icon={faAngleLeft} size="lg" />}
      {...props}
    >
      {t('ui:goBack')}
    </LinkButton>
  );
};
